<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">      
                        <div class="col-lg-6 col-xs-12 col-xl-6 col-md-12">
                            <p class="page-text margin-bottom-20">
                                Visualize abaixo os pacientes cadastrados no Tasy.
                            </p>
                        </div>                                        
                        <div class="col-xl-12">
                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="get">
                                <div class="row">
                                    <div class="col-lg-2 col-xs-4 col-xl-2 col-md-2" style="padding-right: 0px;">
                                        <div class="submit-field">
                                            <h5>Campo:</h5>
                                            <select class="with-border" v-model="form.campo">
                                                <option value="NM_PESSOA_PESQUISA">Nome</option>
                                                <option value="NR_CPF">CPF</option>
                                                <option value="CD_PESSOA_FISICA">Código pessoa física</option>
                                                <option value="CD_SISTEMA_ANT">Código sistema anterior</option>
                                                <option value="NR_PRONTUARIO">Prontuário</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-lg-7 col-xs-8 col-xl-6 col-md-10">
                                        <div class="submit-field">
                                            <h5>Pesquise um paciente:</h5>
                                            <input type="text" class="with-border margin-bottom-0" placeholder="Escreva aqui.." name="pesquisa" v-model="form.pesquisa">
                                        </div>
                                    </div>

                                    <div class="col-lg-3 col-md-2 col-xs-4 hidden-xs hidden-md" style="">
                                        <div class="submit-field">
                                            <div class="clearfix" style="margin-top: 27px;"></div>
                                            <button class="button green small">
                                                <i class="las la-search"></i>
                                                Pesquisar
                                            </button>                                          
                                        </div>
                                    </div>               
                                    <div class="col-lg-3 col-md-4 col-xs-5 hidden-lg hidden-xl margin-bottom-20" style="text-align: right;">
                                        <div class="submit-field">
                                            <!-- <div class="hidden-xl hidden-lg hidden-sm hidden-md margin-top-10"></div> -->
                                            <div class="hidden-xs clearfix hidden-xl hidden-md" style="margin-top: 32px;"></div>
                                            <button class="button green small block-mobile">
                                                <i class="las la-search"></i>
                                                Pesquisar
                                            </button>                                          
                                        </div>
                                    </div>                                                         

                                    <div class="col-xl-12 margin-bottom-20" v-show="!form.pesquisa && form.page == 1">
                                        <h5 class="block-title margin-top-0">
                                            <i class="las la-history"></i>
                                            Pacientes recentes
                                        </h5>
                                        <div class="table-scroll" style="overflow-x: scroll;" v-show="data.ultimos.length > 0">

                                            <table class="table table-bordered table-bordered-default table-responsive">
                                                <thead>
                                                    <th style="min-width: 1px; width: 1px;">
                                                        Código
                                                    </th>
                                                    <th style="min-width: 200px;">
                                                        Nome
                                                    </th>                                        
                                                    <th style="min-width: 120px; width: 120px;">
                                                        CPF
                                                    </th>
                                                    <th style="min-width: 100px; width: 100px;">
                                                        Prontuário
                                                    </th>
                                                    <th style="min-width: 125px; width: 125px;">
                                                        Último acesso     
                                                    </th>                                        
                                                    <th style="min-width: 280px; width: 280px;">
                                                        Ações
                                                    </th>                                                                     
                                                </thead>
                                                <tbody>   
                                                    <tr v-for="(item, index) in data.ultimos" :key="item.cod">
                                                        <td data-label="">
                                                            <a >
                                                                <span class="hidden-xl hidden-lg">Código: </span>{{item.pessoaFisica.CD_PESSOA_FISICA}}
                                                            </a>
                                                        </td>
                                                        <td data-label="Nome">
                                                            <a >
                                                                {{item.pessoaFisica.NM_PESSOA_FISICA}}
                                                            </a>
                                                        </td>                 
                                                        <td data-label="CPF">
                                                            <a >
                                                                {{item.pessoaFisica.NR_CPF}}
                                                            </a>
                                                        </td>  
                                                        <td data-label="Prontuário">    
                                                            {{item.pessoaFisica.NR_PRONTUARIO}}
                                                        </td>    
                                                        <td data-label="Última atualização">    
                                                            {{item.datahora | formatDate}}
                                                        </td>                                                                                        
                                                        <td data-label="Ações" class="" style="text-align: center">
                                                            <router-link :to="{'name': 'Paciente', 'query': {'CD_PESSOA_FISICA': item.pessoaFisica.CD_PESSOA_FISICA}}" style="width: 47%; display: inline-block;" class="dashboard-status-button color-secondary">
                                                                <i class="las la-id-card"></i>
                                                                Ver detalhes
                                                            </router-link>

                                                            <router-link v-if="$root.user.tipo == 'admin'" :to="{'name': 'PermissaoUsoDados', 'query': {'CD_PESSOA_FISICA': item.pessoaFisica.CD_PESSOA_FISICA}}" class="dashboard-status-button gray">
                                                                <i class="las la-lock"></i>
                                                                Permissões
                                                            </router-link>

                                                            <router-link v-if="$root.user.tipo == 'profissional'" :to="{'name': 'GerenciarReceitas', 'query': {'CD_PESSOA_FISICA': item.pessoaFisica.CD_PESSOA_FISICA}}" style="width: 47%; display: inline-block;" class="dashboard-status-button color-secondary">
                                                                <i class="las la-file-alt"></i>
                                                                Emitir receita
                                                            </router-link>
                                                        </td>                                                                                                                                        
                                                    </tr>                                                                      
                                                    
                                                </tbody>
                                            </table>                            
                                        </div> 
                                    </div>

                                    <!-- <div class="col-xs-7 padding-top-12 ">

                                        <div class="hidden-xs margin-top-10"></div>
                                    </div> -->

                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form> 


                            <h5 v-show="data.itens.length == 0 && data.loaded" class="empty">
                                <i class="las la-times"></i>
                                Nenhum resultado encontrado.
                            </h5>

                            <div class="table-scroll" style="overflow-x: scroll;" v-show="data.itens.length > 0">
                                <h5 class="block-title margin-top-0">
                                    <i class="las la-list"></i>
                                    Todos os pacientes
                                </h5>
                                <small v-if="data.total && data.total" style="display: block; line-height: 130%;"><b>{{data.total}}</b> resultado(s) encontrado(s).</small>

                                <table class="table table-bordered table-bordered-default table-responsive margin-top-15">
                                    <thead>
                                        <th style="min-width: 1px; width: 1px;">
                                            Código
                                        </th>
                                        <th style="min-width: 200px;">
                                            Nome
                                        </th>                                        
                                        <th style="min-width: 120px; width: 120px;">
                                            CPF
                                        </th>
                                        <th style="min-width: 100px; width: 100px;">
                                            Prontuário
                                        </th>
                                        <th style="min-width: 125px; width: 125px;">
                                            Última atualização     
                                        </th>                                        
                                        <th style="min-width: 280px; width: 280px;">
                                            Ações
                                        </th>                                                                     
                                    </thead>
                                    <tbody>   
                                        <tr v-for="(item, index) in data.itens" :key="item.CD_PESSOA_FISICA">
                                            <td data-label="">
                                                <a >
                                                    <span class="hidden-xl hidden-lg">Código: </span>{{item.CD_PESSOA_FISICA}}
                                                </a>
                                            </td>
                                            <td data-label="Nome">
                                                <a >
                                                    {{item.NM_PESSOA_FISICA}}
                                                </a>
                                            </td>                 
                                            <td data-label="CPF">
                                                <a >
                                                    {{item.NR_CPF}}
                                                </a>
                                            </td>  
<!--                                             <td data-label="Atendimento">    
                                                -
                                            </td> -->
                                            <td data-label="Prontuário">    
                                                {{item.NR_PRONTUARIO}}
                                            </td>    
                                            <td data-label="Última atualização">    
                                                {{item.DT_ATUALIZACAO | formatDate}}
                                            </td>                                                                                        
                                            <td data-label="Ações" class="" style="text-align: center">
                                                <router-link :to="{'name': 'Paciente', 'query': {'CD_PESSOA_FISICA': item.CD_PESSOA_FISICA}}" style="width: 47%; display: inline-block;" class="dashboard-status-button color-secondary">
                                                    <i class="las la-id-card"></i>
                                                    Ver detalhes
                                                </router-link>

                                                <router-link v-if="$root.user.tipo == 'admin'" :to="{'name': 'PermissaoUsoDados', 'query': {'CD_PESSOA_FISICA': item.CD_PESSOA_FISICA}}" class="dashboard-status-button gray">
                                                    <i class="las la-lock"></i>
                                                    Permissões
                                                </router-link>

                                                <router-link v-if="$root.user.tipo == 'profissional'" :to="{'name': 'GerenciarReceitas', 'query': {'CD_PESSOA_FISICA': item.CD_PESSOA_FISICA}}" style="width: 47%; display: inline-block;" class="dashboard-status-button color-secondary">
                                                    <i class="las la-file-alt"></i>
                                                    Emitir receita
                                                </router-link>
                                            </td>                                                                                                                                        
                                        </tr>                                                                      
                                        
                                    </tbody>
                                </table>                            
                            </div> 


                        </div>
                        <div class="col-xl-12 xs-center">  
                            <div class="pagination-container xs-center margin-top-60 margin-bottom-60">
                                <nav class="pagination xs-center">
                                    <ul>
                                        <li class="pagination-arrow" v-show="data.page > 1" v-on:click="form.page = (data.page - 1); get(true);">
                                            <a>
                                                <i class="las la-arrow-left"></i>
                                                Anterior
                                            </a>
                                        </li>
                                        <li class="pagination-arrow" v-show="data.page >= 1 && data.page < (data.pages.length)" v-on:click="form.page = (data.page + 1); get(true);">
                                            <a>
                                                Próxima
                                                <i class="las la-arrow-right"></i>
                                            </a>
                                        </li>    
                                        <br class="hidden-lg hidden-xl hidden-md">                                        
                                        <li v-for="(item, index) in data.pages" v-show="item.show">
                                            <a class="" v-bind:class="{'current-page': item.index == data.page}" v-on:click="form.page = item.index; get(true);">
                                                {{item.index}}
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>                            
                        </div>                            
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Pacientes',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "data":                 {
                "itens":            [],
                "ultimos":          [],
                "loaded":           false,
            },    
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "campo":            "NM_PESSOA_PESQUISA",
                "page":             1,
                "pesquisa":         ""
            }
        }
    },
    watch: {
                  
    },
    methods: {                
        get: function(pagination) {
            var self        = this;
            console.log("get()");
            return new Promise(function(resolve, reject) {
                loading.show();
                    
                if (!pagination) {
                    if (self.$root.tmp.pacientes.itens.length > 0) {
                        self.form   =   JSON.parse(JSON.stringify(self.$root.tmp.formPacientes));
                        self.data   = JSON.parse(JSON.stringify(self.$root.tmp.pacientes));
                        self.$root.$forceUpdate();
                        self.$forceUpdate();
                        loading.hide();
                        resolve(true);
                    }
                }


                axios.get("api/pacientes.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data           = response.data.result;
                    self.$root.tmp.pacientes = JSON.parse(JSON.stringify(response.data.result));
                    self.$root.tmp.formPacientes = JSON.parse(JSON.stringify(self.form));

                    self.$forceUpdate();
                    self.$root.$forceUpdate();
                    setTimeout(function() {
                        if (pagination) {
                            self.$root.scrollTop();
                        }
                        self.$forceUpdate();
                        resolve(response.data.result);
                    }, 100);
                    setTimeout(function() {
                        if (window.__app.$route.name == "Pacientes") {
                            loading.hide();
                        }

                    }, 500);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        }
    },
    created: function() {
        var self = this;

        self.$root.addLog({
            "acao": "VISUALIZAR_PACIENTES", 
            "referenciaCod": ""
        });


        loading.show();

        Promise.all([
            self.get()
        ]).then(function() {
        
            // self.$forceUpdate();
            
        }).catch(function(error) {
            // loading.hide();
        });         

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/*    .dashboard-status-button {
        padding-top: 0px;
        margin-right: 5px;
    }*/
    .dashboard-status-button i {
        /*color: #fff;*/
    }
</style>



// WEBPACK FOOTER //
// src/components/Pacientes.vue